module.exports = __webpack_public_path__ + "static/media/zoom.e14eb611.svg";